export enum EstiloPopup {
	unknown = 0,
    verde = 1,
    vermelho = 2,
    amarelo = 3,
    azul = 4,
}
